import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/AuthSlice";
import dealSlice from "./slices/DealSlice";
import profileSlice from "./slices/ProfileSlice";
import manageFundSlice from "./slices/manageFundSlice";
import dashboardSlice from "./slices/dashboardSlice";
import ordersSlice from "./slices/OrdersSlice";
import ReportsSlice from "./slices/ReportsSlice";
import EsignSlice from "./slices/EsignSlice";
import walletsSlice from "./slices/WalletsSlice";
import BusinessProfileSlice from "./slices/BusinessProfileSlice";
import invoiceUpload from "./slices/InvoiceuploadSlice";
import SettlementSlice from "./slices/SettlementSlice";
import NotifySlice from "./slices/NotifySlice";
import QuestionnaireSlice from "./slices/QuestionnaireSlice";
import dealReqSlice from "./slices/DealReqSlice";
import dealCategorySlice from "./slices/dealCategorySlice";
import enqMngtKycReducer from "./slices/EnqMngtKycSlice";
import creditLimitReducer from "./slices/CreditLimitSlice";
import supplierReducer from "./slices/supplierSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  dashboard: dashboardSlice,
  deals: dealSlice,
  profile: profileSlice,
  manageFunds: manageFundSlice,
  orders: ordersSlice,
  reports: ReportsSlice,
  esign: EsignSlice,
  invoiceUpload: invoiceUpload,
  wallets: walletsSlice,
  profile1: BusinessProfileSlice,
  settlement: SettlementSlice,
  notification: NotifySlice,
  questionnaire: QuestionnaireSlice,
  dealReq: dealReqSlice,
  dealCategory: dealCategorySlice,
  enqMngt: enqMngtKycReducer,
  creditLimit: creditLimitReducer,
  supplier: supplierReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
